import cf from 'conversational-form';

if($('#chat-form').length > 0) {

    var conversationalForm,
        companies = [],
        errorMessage = false;
        
    const isMobile = function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };
    
    if (isMobile()) {
        $(".hero__image").height($(window).height());
        $(".hero__side").outerHeight($(".hero__image").height());
    }

    // check formless.json
    var onFormlessSubmitted = function(){
        
        $("cf-input").hide();
        
        if (errorMessage) {
            conversationalForm.addRobotChatResponse(errorMessage);
        } else {
            conversationalForm.addRobotChatResponse("{name}, bedankt voor je nominatie!");
        }
    }

    var onStepCallback = function(dto, success, error){
        
        $("body, html").stop().animate({scrollTop:0});
        
        if (! isMobile()) {
            setTimeout(function() {
                $("cf-input textarea").focus();
            }, 1000);
        }
        
        $("cf-input textarea").addClass('animate');
        $("cf-input-button.cf-input-button").fadeIn();
        $(".hero__side h1").addClass('animate');
        $(".hero__side").addClass('animate');
        
        switch (dto.tag.name) {
            case 'nominee_search':
                
                if (dto.text.length < 5) {
                    tags = [{
                        // tag group
                        "tag": "input",
            			"name": "nominee_search",
            			"cf-questions": "Die naam is wel erg kort 😅\nKun je wat specieker zijn? 😉",
			            "cf-input-placeholder": "Type de naam van het leerbedrijf"
                    }];
                                
                    conversationalForm.addTags(tags, true);
                    success();  
                    
                } else {
        
                    $.ajax({
                        url: '/nominate/getCompanies',
                        type: 'GET',
                        dataType: 'json',
                        data: {
                            q: dto.text
                        },
                        error: function(err) {
                            error();
                        },
                        success: function(res) {
                            
                            var tags;
                            
                            if (! res || res.length === 0) {

                                if (companies.length > 0) {
                                    tags = [{
                                        // tag group
                                        "tag": "fieldset",
                                        "name": "nominee_continue",
                                        "cf-questions": "Helaas, we konden geen leerbedrijf vinden met deze naam.",
                                        "cf-input-placeholder": "Wil je opnieuw zoeken?",
                                        "children": [{
                                            "tag": "input",
                                            "type": "radio",
                                            "name": "nominee",
                                            "cf-label": "Opnieuw zoeken",
                                            "value": 1
                                        }, {
                                            "tag": "input",
                                            "type": "radio",
                                            "name": "nominee",
                                            "cf-label": "Overslaan en nominatie afronden",
                                            "value": 0
                                        }]
                                    }];
                                } else {
                                    tags = [{
                                        // tag group
                                        "tag": "input",
                                        "name": "nominee_search",
                                        "cf-questions": "Helaas, we konden geen leerbedrijf vinden met deze naam. Probeer het nog eens 🙂",
                                        "cf-input-placeholder": "Type de naam van het leerbedrijf"
                                    }];
                                }
                            } else if (res.length === 1) {
                                tags = [{
                                    "tag": "fieldset",
                                    "cf-input-placeholder": "Bevestig het gekozen leerbedrijf",
                                    "cf-questions": "Ok, je wilt "+ res[0].title + " nomineren. Klopt dat?",
                                    "children": [{
                                        "tag": "input",
                                        "type": "radio",
                                        "name": "nominee",
                                        "cf-label": "Yes 👍",
                                        "value": res[0].id
                                    }, {
                                        "tag": "input",
                                        "type": "radio",
                                        "name": "nominee",
                                        "cf-label": "Nee, ik bedoelde een ander leerbedrijf",
                                        "value": "-1"
                                    }]
                                }];
                            } else {
                                
                                var nominees = res.map(i => {
                                    return {
                                        "tag": "input",
                                        "type": "radio",
                                        "name": "nominee",
                                        "cf-label": i.title,
                                        "value": i.id
                                    }
                                });
                                
                                if (companies.length > 0) {

                                    tags = [{
                                        "tag": "fieldset",
                                        "cf-input-placeholder": "Kies een leerbedrijf",
                                        "cf-questions": "We hebben meerdere leerbedrijven gevonden met deze naam.\nStaat jouw leerbedrijf hieronder?",
                                        "children": [...nominees, {
                                            "tag": "input",
                                            "type": "radio",
                                            "name": "nominee",
                                            "cf-label": "Mijn leerbedrijf staat er niet tussen",
                                            "value": "-1"
                                        }, {
                                            "tag": "input",
                                            "type": "radio",
                                            "name": "nominee",
                                            "cf-label": "Overslaan en nominatie afronden",
                                            "value": "-2"
                                        }]
                                    }];
                                } else {

                                    tags = [{
                                        "tag": "fieldset",
                                        "cf-input-placeholder": "Kies een leerbedrijf",
                                        "cf-questions": "We hebben meerdere leerbedrijven gevonden met deze naam.\nStaat jouw leerbedrijf hieronder?",
                                        "children": [...nominees, {
                                            "tag": "input",
                                            "type": "radio",
                                            "name": "nominee",
                                            "cf-label": "Mijn leerbedrijf staat er niet tussen",
                                            "value": "-1"
                                        }]
                                    }];
                                }
                            }
                                
                            conversationalForm.addTags(tags, true);
                            success();   
                        }
                    });
                }
                
                break;

            case 'nominee_continue':

                if (dto.tag.value && dto.tag.value[0] && parseInt(dto.tag.value[0]) == 1) {
                    var tags = [{
                        "tag": "input",
                        "name": "nominee_search",
                        "cf-questions": "Ok, we proberen het opnieuw 🙂\nWat is de naam van het bedrijf dat je wilt nomineren?",
                        "cf-input-placeholder": "Type de naam van het leerbedrijf"
                    }];
                            
                    conversationalForm.addTags(tags, true);

                    success();
                } else {
                    $.post('/nominate/submit', {...conversationalForm.getFormData(true), 'companies': companies}, function(res) {
                        res = $.parseJSON(res);
                        if (res.status != 'success') {
                            errorMessage = res.error || 'Er ging iets mis met je nominatie. Probeer het op een later moment opnieuw.';
                            console.log(errorMessage);
                        }
                        success();
                    });
                }

                break;
        
            case 'nominee':
                
                if (dto.tag.value && dto.tag.value[0] && parseInt(dto.tag.value[0]) == -1) {
                    
                    var tags = [{
                        "tag": "input",
            			"name": "nominee_search",
            			"cf-questions": "Ok, we proberen het opnieuw 🙂\nWat is de naam van het bedrijf dat je wilt nomineren?",
			            "cf-input-placeholder": "Type de naam van het leerbedrijf"
                    }];
                            
                    conversationalForm.addTags(tags, true);
                
                    success();

                } else if (dto.tag.value && dto.tag.value[0] && parseInt(dto.tag.value[0]) == -2) {
                    
                    $.post('/nominate/submit', {...conversationalForm.getFormData(true), 'companies': companies}, function(res) {
                        res = $.parseJSON(res);
                        if (res.status != 'success') {
                            errorMessage = res.error || 'Er ging iets mis met je nominatie. Probeer het op een later moment opnieuw.';
                            console.log(errorMessage);
                        }
                        success();
                    });

                } else {
                    
                    var data = conversationalForm.getFormData(true);
                    
                    companies.push(data.nominee[0]);
                    
                    //check if name / email / jurgroup is set
                    if (data && data.email && data.email.length > 3) {
                        var tags = [{
                            "tag": "fieldset",
                			"name": "confirm",
                			"cf-questions": "Ok, we hebben alles wat we nodig hebben. Wil je je nominatie indienen?",
                			"children": [
                				{
                					"tag": "input",
                					"type": "radio",
                					"name": "confirm",
                					"cf-label": "Ja",
                					"value": "1"
                				}, {
                					"tag": "input",
                					"type": "radio",
                					"name": "confirm",
                					"cf-label": "Nee, kies nog een leerbedrijf",
                					"value": "0"
                				}
                			]
                        }];
                            
                        conversationalForm.addTags(tags, true);
                    }
                
                    success();
                }
                
                break;
                
                
            case 'email':
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                
                if (re.test(String(dto.text).toLowerCase().trim())) {
                    success();
                    
                } else {
                    error();
                }
                
                break;
                
            case 'name':
            case 'school':
                
                if (dto.text.length < 4) {
                    error();
                } else {
                    success();
                }
                
                break;
                
            case 'confirm':
                
                if (parseInt(dto.tag.value[0]) === 0) {
                    var tags = [{
                        "tag": "input",
            			"name": "nominee_search",
            			"cf-questions": "Wat is de naam van het bedrijf dat je wilt nomineren?",
            			"cf-conditional-confirm": "0",
			            "cf-input-placeholder": "Type de naam van het leerbedrijf"
                    }];
                            
                    conversationalForm.addTags(tags, true);
                    
                    success();
                } else {
                    $.post('/nominate/submit', {...conversationalForm.getFormData(true), 'companies': companies}, function(res) {
                        res = $.parseJSON(res);
                        if (res.status != 'success') {
                            errorMessage = res.error || 'Er ging iets mis met je nominatie. Probeer het op een later moment opnieuw.';
                            console.log(errorMessage);
                        }
                        success();
                    });
                }
                
                break;
                
            default:
            
                success();
            
        }
    }

    // load json file with formless data (files/formless.json)
    var xhr = new XMLHttpRequest()
    xhr.onload = function(event){
        var str = xhr.response;
        var json = JSON.parse(str);

        // add callback hooks..
        json.options.submitCallback = onFormlessSubmitted.bind(window);
        json.options.flowStepCallback = onStepCallback.bind(window);
        json.options.formEl = $("#chat-form")[0];
        
        // start one w. json
        conversationalForm = cf.startTheConversation(json);
        document.getElementById("cf-context").appendChild(conversationalForm.el);
        
    }
    xhr.open("GET", "/application/themes/blh19/data/chat.json?v=3");
    xhr.send();
    
}


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/chat.js